import { tokens } from 'smoothie';

export const RETIREMENT_CALCULATOR_COLORS = {
    ASSETS: tokens.color.light.green.green1000,
    CONTRIBUTIONS: tokens.color.light.dropletBlue.dropletBlue1000,
    GROWTH: tokens.color.light.green.green1000,
    DISTRIBUTIONS: tokens.color.light.orange.orange1000,
    SOCIAL_SECURITY: tokens.color.light.dropletBlue.dropletBlue1200,
    INFLOWS: tokens.color.light.sweetViolet.sweetViolet1000,
    EXPENSES: tokens.color.light.red.red1000,
    TAXES: tokens.color.light.red.red800,
    HEALTHCARE: tokens.color.light.red.red900,
    LONG_TERM_CARE: tokens.color.light.red.red900,
} as const;

// Helper function to get calendar year from year index
export const getCalendarYear = (yearNumber: number): number => {
    const currentCalendarYear = new Date().getFullYear();
    return currentCalendarYear + yearNumber;
};

// Helper function to get year index from year.
export const getYearIndex = (year: number): number => {
    return year - 1; // Year 1 is the first year.
};
